import * as types from 'modules/campaigns/actionTypes';

/**
 * @param {string} campaignId
 * @param {Object} [meta={}]
 * @returns {import("modules/interventions/types/actions").OpenSendModalAction}
 */
export const openSendModal = (campaignId, meta = {}) => ({
  type: types.OPEN_SEND_MODAL,
  payload: campaignId,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("modules/interventions/types/actions").CloseSendModalAction}
 */
export const closeSendModal = (meta = {}) => ({
  type: types.CLOSE_SEND_MODAL,
  meta,
});

/**
 * @param {boolean} state
 * @param {Object} [meta={}]
 * @returns {import("modules/interventions/types/actions").SendModalReadyAction}
 */
export const sendModalReady = (state, meta = {}) => ({
  type: types.SEND_MODAL_READY,
  payload: state,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("modules/interventions/types/actions").OpenSendTestModalAction}
 */
export const openSendTestModal = (meta = {}) => ({
  type: types.OPEN_SEND_TEST_MODAL,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("modules/interventions/types/actions").CloseSendTestModalAction}
 */
export const closeSendTestModal = (meta = {}) => ({
  type: types.CLOSE_SEND_TEST_MODAL,
  meta
});
